import {Component, EventEmitter, Input, Output,} from '@angular/core';

@Component({
  selector: 'app-core-popup',
  templateUrl: './core-popup.component.html',
  styleUrls: ['./core-popup.component.scss'],
})
export class CorePopupComponent {
  visible = false;

  @Input() header: string = '';
  @Input() saveText: string = '';
  @Input() saveButtonDisable: boolean = false;
  @Input() showFooter: boolean = true;
  @Input() maximizable: boolean = false;
  @Input() modal: boolean = true;
  @Input() breakpoints: { [key: string]: string } = {'1199px': '75vw', '575px': '90vw'};
  @Input() dialogStyle: { [key: string]: string } = {};
  @Input() resizable: boolean = false
  @Output() chooseOn = new EventEmitter();
  @Output() closeOn = new EventEmitter();

  @Input() showSecondButton: boolean = false;
  @Input() secondButtonDisable: boolean = false;
  @Input() hideCancel: boolean = false;
  @Input() secondButtonText: string = '';
  @Output() secondButtonChooseOn = new EventEmitter();

  constructor() {
  }

  openDialog() {
    this.visible = true;
  }

  closeDialog() {
    this.visible = false;
    this.closeOn.emit();
  }

  save() {
    this.chooseOn.emit()
  }

  secondButtonSave() {
    this.secondButtonChooseOn.emit()
  }
}
